const routers = [
    // 测试专用,最后将会删除
    {
        path: '/test',
        name: 'test',
        component(resolve) {
            require.ensure(['./views/infoBox/inboxActive.vue'], () => {
                resolve(require('./views/infoBox/inboxActive.vue'));
            });
        }
    },
    // 消息中心页面 -- yy
    {
        path: '/inboxInfo',
        name: 'inboxInfo',
        component(resolve) {
            require.ensure(['./views/infoBox/inboxInfo.vue'], () => {
                resolve(require('./views/infoBox/inboxInfo.vue'));
            });
        }
    },
    // 消息中心--通知页面--yy
    {
        path: '/inboxInform',
        name: 'inboxInform',
        component(resolve) {
            require.ensure(['./views/infoBox/inboxInform.vue'], () => {
                resolve(require('./views/infoBox/inboxInform.vue'));
            });
        }
    },
    // 消息中心--活动页面--yy
    {
        path: '/inboxActive',
        name: 'inboxActive',
        component(resolve) {
            require.ensure(['./views/infoBox/inboxActive.vue'], () => {
                resolve(require('./views/infoBox/inboxActive.vue'));
            });
        }
    },
    // 统一入口--常见问题--yy
    {
        path: '/commonQuest',
        name: 'commonQuest',
        component(resolve) {
            require.ensure(['./views/unifiedEntrance/commonQuest.vue'], () => {
                resolve(require('./views/unifiedEntrance/commonQuest.vue'));
            });
        }
    },
    // 统一入口--用户反馈--yy
    {
        path: '/feedBack',
        name: 'feedBack',
        component(resolve) {
            require.ensure(['./views/unifiedEntrance/feedBack.vue'], () => {
                resolve(require('./views/unifiedEntrance/feedBack.vue'));
            });
        }
    },
    // 统一入口--试算器详情页--yy
    {
        path: '/applianceDetail',
        name: 'applianceDetail',
        component(resolve) {
            require.ensure(['./views/unifiedEntrance/applianceDetail.vue'], () => {
                resolve(require('./views/unifiedEntrance/applianceDetail.vue'));
            });
        }
    },
    // 统一入口--选择城市页--yy
    {
        path: '/cityList',
        name: 'cityList',
        component(resolve) {
            require.ensure(['./components/unifiedEntrance/cityList.vue'], () => {
                resolve(require('./components/unifiedEntrance/cityList.vue'));
            });
        }
    },
    // 统一入口--家电套购--yy
    {
        path: '/appliance',
        name: 'appliance',
        component(resolve) {
            require.ensure(['./views/unifiedEntrance/appliance.vue'], () => {
                resolve(require('./views/unifiedEntrance/appliance.vue'));
            });
        }
    },
    // 统一入口--消费首页--yy
    /* {
        path: '/custom',
        name: 'custom',
        component(resolve) {
            require.ensure(['./views/unifiedEntrance/custom.vue'], () => {
                resolve(require('./views/unifiedEntrance/custom.vue'));
            });
        }
    }, */
    // 统一入口--app下载页--yy
    {
        path: '/download',
        name: 'download',
        component(resolve) {
            require.ensure(['./views/unifiedEntrance/download.vue'], () => {
                resolve(require('./views/unifiedEntrance/download.vue'));
            });
        }
    },
    // 统一入口--商品分期详情--yy
    {
        path: '/installmentDetail',
        name: 'installmentDetail',
        component(resolve) {
            require.ensure(['./views/unifiedEntrance/installmentDetail.vue'], () => {
                resolve(require('./views/unifiedEntrance/installmentDetail.vue'));
            });
        }
    },
    // 统一入口--商品分期--yy 备注:由于代码的变更, 导致installment现在司机指向的地址是 installmentList
    {
        path: '/installment',
        name: 'installment',
        component(resolve) {
            require.ensure(['./views/unifiedEntrance/installmentList.vue'], () => {
                resolve(require('./views/unifiedEntrance/installmentList.vue'));
            });
        }
    },
    // 统一入口--商品分期--yy 次级目录
    {
        path: '/installmentList',
        name: 'installmentList',
        component(resolve) {
            require.ensure(['./views/unifiedEntrance/installment.vue'], () => {
                resolve(require('./views/unifiedEntrance/installment.vue'));
            });
        }
    },
    // 统一入口--美易分介绍页--liudg-20171229
    {
        path: '/myfDetail',
        name: '美易分介绍页',
        component(resolve) {
            require.ensure(['./views/unifiedEntrance/myfDetail.vue'], () => {
                resolve(require('./views/unifiedEntrance/myfDetail.vue'));
            });
        }
    }];

export default routers;



// WEBPACK FOOTER //
// ./src/routers.js